import { prop } from 'ramda'
import { createSelector } from 'redux-bundler'

import { hours } from 'milliseconds'

const SNOOZE_INTERVAL = hours(24)

const ACTION = {
  ALERT_DISMISSED: 'ALERT_DISMISSED',
  DISMISSED_ALERTS_CLEARED: 'DISMISSED_ALERTS_CLEARED',
  ALERT_SNOOZED: 'ALERT_SNOOZED',
  SNOOZED_ALERTS_REPLACE: 'SNOOZED_ALERTS_REPLACE',
}

const initialState = {
  dismissed: [],
  snoozed: [],
}

const bundle = {
  name: 'alerts',
  reducer: (state = initialState, action = {}) => {
    switch (action.type) {
      case ACTION.ALERT_DISMISSED:
        return {
          ...state,
          dismissed: Array.isArray(action.payload)
            ? [...state.dismissed, ...action.payload]
            : [...state.dismissed, action.payload],
        }
      case ACTION.DISMISSED_ALERTS_CLEARED:
        return { ...state, dismissed: [] }
      case ACTION.ALERT_SNOOZED:
        const { snoozed = [] } = state
        return {
          ...state,
          snoozed: [snoozed, [Date.now(), action.payload]],
        }
      case ACTION.SNOOZED_ALERTS_REPLACE:
        return {
          ...state,
          snoozed: action.payload,
        }
      default:
        return state
    }
  },
  selectAlerts: prop('alerts'),
  selectDismissedAlerts: createSelector('selectAlerts', ({ dismissed = [], snoozed = [] }) => [
    ...dismissed,
    ...snoozed.map(([, key]) => key),
  ]),
  doDismissAlert: key => ({ type: ACTION.ALERT_DISMISSED, payload: key }),
  doClearDismissedAlerts: () => ({ type: ACTION.DISMISSED_ALERTS_CLEARED }),
  doSnoozeAlert: key => ({ type: ACTION.ALERT_SNOOZED, payload: key }),
  reactRestoreSnoozedAlerts: createSelector('selectAlerts', 'selectAppTime', ({ snoozed = [] }) => {
    if (!snoozed.length) return null
    const now = Date.now()
    const notExpired = snoozed.filter(([ts]) => ts + SNOOZE_INTERVAL > now)
    if (notExpired.length !== snoozed.length) {
      return { type: ACTION.SNOOZED_ALERTS_REPLACE, payload: notExpired }
    }
  }),
  persistActions: Object.values(ACTION),
}

export default bundle
